import { useAuth } from 'context/AuthProvider'
import React, { useEffect, useState } from 'react'
import { Card, CardHeader, Pagination, PaginationItem, PaginationLink, Table } from 'reactstrap'
import { apiAusenciasService } from 'services/apiAusenciasService'

const IncidenciasEnVacaciones = () => {
    const {empresa} = useAuth();
    const year = new Date().getFullYear();

    const [incidenciaVacaciones, setIncidenciasVacaciones] = useState([])
    const [page, setPage] = useState(1)
    const pageSize = 10
    const maxPagesToShow = 5


    useEffect(() => {
        const fetchData = async () =>{
            const response = await apiAusenciasService.getIncidenciasVacaciones(empresa.id,year )
            setIncidenciasVacaciones(response)
        }

        fetchData()

        

    
      return () => {
        
      }
    }, [year, empresa.id])

    const totalPages = Math.max(1, Math.ceil(incidenciaVacaciones.length / pageSize))

    useEffect(() => {
        if (page > totalPages) {
            setPage(totalPages)
        }
    }, [page, totalPages])

    const start = (page - 1) * pageSize
    const incidenciasPaginadas = incidenciaVacaciones.slice(start, start + pageSize)

    const goToPage = (nextPage) => {
        const clamped = Math.min(Math.max(nextPage, 1), totalPages)
        setPage(clamped)
    }

    const getVisiblePages = () => {
        if (totalPages <= maxPagesToShow) {
            return Array.from({ length: totalPages }, (_, i) => i + 1)
        }
        const half = Math.floor(maxPagesToShow / 2)
        let startPage = page - half
        let endPage = page + half
        if (maxPagesToShow % 2 === 0) {
            endPage -= 1
        }
        if (startPage < 1) {
            startPage = 1
            endPage = maxPagesToShow
        }
        if (endPage > totalPages) {
            endPage = totalPages
            startPage = totalPages - maxPagesToShow + 1
        }
        return Array.from(
            { length: endPage - startPage + 1 },
            (_, i) => startPage + i
        )
    }
    


  return (
    <>
        {incidenciaVacaciones.length> 0  &&
         <Card Card style={{borderColor:'red'}}>
                <CardHeader >
                    Existen incidencias en las vacaciones
                </CardHeader>
                    <Table className='text-center table-flush' responsive>
                        <thead className='thead-light'>
                        <th>Apellidos</th>
                        <th>Nombre</th>
                        <th>Vacaciones actuales</th>
                        <th>Vacaciones permitidas</th>
                        </thead>
                        <tbody>
                            {incidenciasPaginadas.map(incidencia =>(
                                <tr key={incidencia.id}>
                                    <td>{incidencia.apellidos}</td>
                                    <td>{incidencia.nombre}</td>
                                    <td className='text-danger'>{incidencia.vacacionesActuales}</td>
                                    <td>{incidencia.vacacionesPermitidas}</td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                    {incidenciaVacaciones.length > pageSize && (
                        <div className="d-flex justify-content-center p-3">
                            <Pagination aria-label="Paginación de incidencias">
                                <PaginationItem disabled={page === 1}>
                                    <PaginationLink previous onClick={() => goToPage(page - 1)} />
                                </PaginationItem>
                                {getVisiblePages().map((pageNumber) => (
                                    <PaginationItem active={pageNumber === page} key={pageNumber}>
                                        <PaginationLink onClick={() => goToPage(pageNumber)}>
                                            {pageNumber}
                                        </PaginationLink>
                                    </PaginationItem>
                                ))}
                                <PaginationItem disabled={page === totalPages}>
                                    <PaginationLink next onClick={() => goToPage(page + 1)} />
                                </PaginationItem>
                            </Pagination>
                        </div>
                    )}

               

            </Card>
        }
    </>
  )
}

export default IncidenciasEnVacaciones
